import { Parse } from 'parse';
Parse.initialize(process.env.REACT_APP_APP_ID, null, process.env.REACT_APP_MASTER_KEY);
Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
Parse.serverURL = process.env.REACT_APP_SERVER_URL;

export const currentPageUsers = new Set();

export const dataProvider = {
  getList: async (resource, params) => {
    const sessionToken = localStorage.getItem('sessionToken');
    const operatorId = localStorage.getItem('operatorId');

    const { pagination, filter = {} } = params;

    const page = pagination?.current || 1;
    const perPage = pagination?.pageSize || 10;

    try {
      const response = await Parse.Cloud.run(
        resource,
        {
          page,
          perPage,
          operatorId, // ✅ IMPORTANT
          filter
        },
        {
          sessionToken // ✅ VERY IMPORTANT
        }
      );

      return {
        data: response.data?.data || [],
        total: response.data?.total || 0
      };
    } catch (error) {
      console.error('getList error:', error);
      throw error;
    }
  },

  getOne: async (resource, params) => {
    const sessionToken = localStorage.getItem('sessionToken');
    const operatorId = localStorage.getItem('operatorId');

    const response = await Parse.Cloud.run(
      resource,
      {
        id: params.id,
        operatorId
      },
      { sessionToken }
    );

    return {
      data: response.data
    };
  },

  create: async (resource, params) => {
    const sessionToken = localStorage.getItem('sessionToken');
    const operatorId = localStorage.getItem('operatorId');

    const response = await Parse.Cloud.run(
      resource,
      {
        ...params.data,
        operatorId
      },
      { sessionToken }
    );

    return {
      data: response.data
    };
  },

  getMany: async (resource, params) => {
    const sessionToken = localStorage.getItem('sessionToken');
    const operatorId = localStorage.getItem('operatorId');

    const response = await Parse.Cloud.run(
      resource,
      {
        ids: params.ids,
        operatorId
      },
      { sessionToken }
    );

    return {
      data: response.data
    };
  }
};
